import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

function ViewOutlet(props) {
  const [title] = useState("Outlet Info | Chimera Solutions | Insights");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const location = useLocation();

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const outletChange = async (groupData, group, brand, chain) => {
    let groupIndex = groupData.brands
      .map((brands, index) => ({
        ...brands,
        chains: brands.chains
          .map((chains, key) => ({ ...chains, index: key }))
          .find((chains) => chains.chaKey === chain.chaKey),
        index: index,
      }))
      .find((brands) => brands.braKey === chain.brand.braKey);

    groupData.brands[groupIndex.index].chains[groupIndex.chains.index].status =
      groupData.brands[groupIndex.index].chains[groupIndex.chains.index]
        .status === 1
        ? 0
        : 1;

    let updatedData = {
      ...groupData,
    };

    try {
      await axios.put(
        props.chimeraserv.urlPost + "/group/update",
        updatedData,
        {
          headers,
        }
      );
      // Optionally, update UI or refetch data here
    } catch (error) {
      // Handle error if needed
    }
  };

  const valueChange = async (dataObj, key) => {
    const updatedData = { ...dataObj, status: dataObj.status === 1 ? 0 : 1 };

    try {
      await axios.put(
        props.chimeraserv.urlPost + "/group/update",
        updatedData,
        {
          headers,
        }
      );
      setLoad(false);
      setData([updatedData]);
      setLoad(true);
    } catch (error) {
      setLoad(false);
    }
  };

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get(props.chimeraserv.urlGet + "/group/", {
        headers,
      });
      const groups = response.data;
      const filtered = groups
        .filter((group) =>
          group.brands.find((brand) =>
            brand.chains.find((chain) => chain.chaKey === props.match.params.id)
          )
        )
        .map((group) => ({
          ...group,
          brands: group.brands
            .filter((brand) =>
              brand.chains.find(
                (chain) => chain.chaKey === props.match.params.id
              )
            )
            .map((brand) =>
              brand.chains.filter(
                (chain) => chain.chaKey === props.match.params.id
              )
            ),
        }));
      setData(filtered);
      setLoad(true);
    } catch (error) {
      setData([]);
      setLoad(true);
    }
    // eslint-disable-next-line
  }, [props.chimeraserv.urlGet, props.match.params.id, props.user.data.usrKey]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [loadData]);

  const Loader =
    props.components && props.components.setting && props.components.setting[1]
      ? props.components.setting[1].component
      : () => <div>Loading...</div>;

  return (
    <div className={["custForm", "custView"].join(" ")}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>Outlet Info</div>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <div className={["form", "fullWidth"].join(" ")}>
            {data.map((group) =>
              group.brands.map((brand, key) =>
                brand.map((chain) => (
                  <div key={chain.chaKey}>
                    <div className={["form-group"]}>
                      <label htmlFor="exampleInputEmail1">Brand Name</label>
                      <div className={["field", "value"].join("_")}>
                        {chain.name}
                      </div>
                    </div>
                    <div className={["form-group"]}>
                      <label htmlFor="exampleInputEmail1">Status</label>
                      <div className={["field", "value"].join("_")}>
                        {chain.status ? "Active" : "Inactive"}
                      </div>
                    </div>
                    <div className={["form-group"]}>
                      <label htmlFor="exampleInputEmail1">Chain Key</label>
                      <div className={["field", "value"].join("_")}>
                        {chain.chaKey}
                      </div>
                    </div>
                    {props.user.data.level === 0 ? (
                      <div className={["actions", "actionsAdmin"].join(" ")}>
                        <Link
                          to={
                            location.pathname
                              .split("/")
                              .splice(0, 3)
                              .join("/") +
                            "/outlet/edit/" +
                            chain.chaKey
                          }
                          className={["btn btn-primary"]}
                        >
                          Edit
                        </Link>
                        <button
                          type={"button"}
                          // onClick={() => valueChange(data, key)}
                          className={["btn", "btn-primary", "disable"].join(
                            " "
                          )}
                        >
                          {data.status ? "Disable" : "Enable"}
                        </button>
                      </div>
                    ) : (
                      <div />
                    )}
                  </div>
                ))
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewOutlet;
